const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');
const { optimaConfigConstants } = require('../../optima.js');

module.exports = {
  displayName: 'Combine Type',
  description: 'Set Combine Type',
  sortOrder: 5,
  name: 'combineType',
  documentKey: 'combine_type',
  values: {
    combineType: {
      dataType: NIMBUS_DATA_TYPES.INTEGER,
      defaultValue: optimaConfigConstants.combineType.CONSIGNEE,
      allowedValues: Object.values(optimaConfigConstants.combineType),
      displayName: 'Combine Type',
      documentKey: 'combine_type',
    },
  },
};
